import $, { ajaxSetup } from "jquery";
window.jQuery = $;
window.$ = $;

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';

import Swup from "swup";
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';

import Headroom from 'headroom.js/dist/headroom.js';
window.Headroom = Headroom;

import sal from 'sal.js'

import { intro } from './components/intro';
import { header } from './components/header';
import { nav } from './components/nav';
import { anchorLinks } from './components/anchor-links';
import { collapsibleSections } from './components/collapsible-sections';
import { toggleSections } from './components/toggle-sections';
import { filters } from './components/filters';
import { map } from './components/map';
import { videos } from './components/videos';
import { footer } from './components/footer';

window.main = window.main || {};

const $body = $('body');
const $mobileNav = $('.js-mobile-nav');

let isHomepage = false;
let isEdition = false;
let isTouchDevice = false;
let isNavToggled = false;
let introRan = false;

function checks() {

  function checkIfTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
  }

  if(checkIfTouchDevice() === true) {
    $body.addClass('is-touch');
    $body.addClass('is-mobile-device');
    isTouchDevice = true;
  }
  else {
    isTouchDevice = false;
  }

  if($body.hasClass('page-home')) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

  if($body.hasClass('page-edition')) {
    isEdition = true;
  } else {
    isEdition = false;
  }

}

function setupPlugins() {

  function initSwup() {

    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#main"],
      plugins: [
          new SwupPreloadPlugin(),
          new SwupScrollPlugin({
            animateScroll: false
          }),
          new SwupBodyClassPlugin({
            prefix: 'page-'
          })
      ]
    };
  
    const swup = new Swup(options);
  
    swup.on('contentReplaced', () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });

  }

  if(!isEdition) {
    initSwup();
  }

}

function swupActiveLinks(){
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll('nav a'); // <- put your link selector here
  for (const link of links) {
      let linkPath = (new URL( link.href )).pathname;
      link.ariaCurrent = linkPath == currentPath ? 'page' : false;
  }
}

function swupReload() {
  
  sal({
    threshold: 0.1,
    once: true
  });

  $mobileNav.attr('aria-hidden',true);
  $body.attr('data-menu-open','false');
  $body.removeClass('no-scroll');
  isNavToggled = false;
 
  intro(introRan,isHomepage,isEdition);
  nav(isNavToggled);
  toggleSections();
  filters();
  map('.js-map');
  videos();

}

function init() {

  sal({
    threshold: 0.1,
    once: true
  });
  
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  const introelement = document.getElementById('intro');
  if (typeof(introelement) != 'undefined' && introelement != null) {
    intro(introRan,isHomepage,isEdition);
    introRan = true;
  }
  
  anchorLinks(introRan,isHomepage,isEdition);
  header(isTouchDevice);
  nav(isNavToggled);
  toggleSections();
  filters();
  map('.js-map');
  videos();
  footer();

}


checks();
setupPlugins();
init();
